import { Component, OnDestroy, OnInit } from '@angular/core';
import { faShoppingCart, faArrowLeft, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ProductsService } from "../../../../shared/services/products.service";
import { ActivatedRoute, Router } from "@angular/router";
import { filter, takeUntil } from "rxjs/operators";
import { Product, SelectedZone, User } from "../../../../shared/models";
import { of, Subject } from "rxjs";
import { LanguageService } from "../../../../shared/services/language.service";
import { ZonesService } from "../../../../shared/services/zones.service";
import { PhoneRechargeSelectionComponent } from "../phone-recharge-selection/phone-recharge-selection.component";
import { MatDialog } from "@angular/material/dialog";
import { StoreService } from "../../../../shared/services/store.service";
import { CutomQuantityModalComponent } from '../cutom-quantity-modal/cutom-quantity-modal.component';
import { Location } from '@angular/common';
import { AgeModalComponent } from '../age-modal/age-modal.component';
import { CookieService } from 'ngx-cookie-service';
import { LoginToAddCartDialogComponent } from "../login-to-add-cart-dialog/login-to-add-cart-dialog.component";
import { AuthService } from "../../../../shared/services/auth.service";
import { NewCartService } from "../../../../shared/services/newcart.service";
import { ErrorsEnum } from "../../../../shared/enum/errors.enum";
import { ExtraData } from "../../../../shared/models/new-cart.model";
import { PendingOrdersConfirmationComponent } from "../pending-orders-confirmation/pending-orders-confirmation.component";
import { NewCheckoutEnum } from "../../../../shared/enum/checkout.enum";
import { ApiService } from "../../../../shared/services/api.service";
import { DynamicCOnfigService } from 'src/app/shared/services/dynamic-config.service';
import {AddToShopListComponent} from "../shopping-list/add-to-shop-list/add-to-shop-list.component";
import {ConfirmDialogComponent} from "../confirm-dialog/confirm-dialog.component";


@Component({
    selector: 'app-product-page',
    templateUrl: './product-page.component.html',
    styleUrls: ['./product-page.component.scss']
})
export class ProductPageComponent implements OnInit, OnDestroy {
    cart_icon = faShoppingCart;
    faArrowLeft = faArrowLeft;
    quantity = 1;
    productSlug!: string;
    productId!: number;
    defaultProduct: any;
    product: Product = {
        id: 0,
        imageUrl: '../../../../../assets/imgs/product-card/no-product-image.png',
        isFavorite: false,
        name: '',
        price: 0,
        isLowStock: false,
        inStock: false,
        quantity: 1,
        currency: '',
        discount: 0,
        slug: '',
        data_extra_types: [],
        top: 0,
        compare_at_price: 0,
        previous_price: 0,
        age_valid: false
    };
    products: Product[] = [];
    productImages: string[] = [];

    destroy$: Subject<boolean> = new Subject<boolean>();


    actualPage: number = 1;
    totalPages: number = 2;
    skeletons: number[] = [];

    relatedProducts: any[] = [];

    isLoadingProduct: boolean = true;
    faSpinner = faSpinner;
    isLoadingCart = false;
    compare_top: any = 0;
    compare_min: any = 1;

    currentUser: User | undefined;

    queryId: string | undefined;
    queryPosition: number | undefined;
    bought_together_products: any[] = [];

    constructor(
        private readonly productsService: ProductsService,
        private readonly activeRoute: ActivatedRoute,
        private readonly languageService: LanguageService,
        private readonly zonesService: ZonesService,
        private readonly dialog: MatDialog,
        private readonly storeService: StoreService,
        private readonly location: Location,
        private readonly cookieService: CookieService,
        private readonly authService: AuthService,
        private readonly newCartService: NewCartService,
        private readonly router: Router,
        private readonly apiService: ApiService,
        private readonly dynamicConfigService: DynamicCOnfigService,
    ) {}

    back() {
        this.location.back();
    }

    ngOnInit(): void {
      this.activeRoute.queryParams
        .pipe(
          takeUntil(this.destroy$)
        )
        .subscribe(({ queryId, queryPosition, productId }) => {
          if (queryId && queryPosition && productId) {
            this.queryId = queryId;
            this.queryPosition = queryPosition;
            this.productId = productId;
          }
        });
        this.activeRoute.params.subscribe((routeParams: any) => {
            window.scroll({ top: 0 });
            this.isLoadingProduct = true;
            this.productSlug = routeParams['slug'];
            this.languageService.selectedLanguage
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                  this.activeRoute.queryParams
                    .pipe(
                      takeUntil(this.destroy$)
                    )
                    .subscribe(({ queryId, queryPosition, productId }) => {
                      let data = {
                        slug : this.productSlug,
                        zoneId: this.getSelectedZone?.zone?.toString(),
                        municipalityId: this.getSelectedZone?.municipality?.toString(),
                        productId: productId,
                        queryId: queryId,
                        queryPosition: queryPosition
                      }
                      this.productsService.getProductBySlugNew(data).subscribe((prod: any) => {
                        this.defaultProduct = { ...prod?.data };

                        this.defaultProduct.min = this.defaultProduct?.min === 0 ? 1 : this.defaultProduct?.min;

                        this.compare_top = this.defaultProduct?.top;
                        this.compare_min = this.defaultProduct.min;
                        this.quantity = this.defaultProduct.min > 1 ? this.defaultProduct.min : 1;
                        // @ts-ignore
                        this.products = [...prod?.data?.variants || []];
                        this.product = this.products[0];
                        this.productImages = [...this.defaultProduct?.imageUrl || [], ...this.product?.images || []];
                        this.defaultProduct.imageUrl = this.productImages[0];
                        this.isLoadingProduct = false;
                        if (this.defaultProduct?.objectID) {
                          this.loadDynamicQueriesByKey('bought-together');
                          this.loadDynamicQueriesByKey('related-products');
                        }
                      })
                    });

                })
        })

        this.currentUser = this.authService.getCurrentUser();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe(); //  You can replace this with this.destroy$.complete() as well
    }

    get getSelectedZone(): SelectedZone {
        return this.zonesService.getZonesValuesStorage();
    }

    increaseQuantity() {
        if (this.getValidSelectedZone) {
            if ((this.quantity < this.compare_top && this.compare_top !== null)) {
                this.quantity += 1;
            }
            if (this.compare_top == null) {
                this.quantity += 1;
            }
        }
    }

    decreaseQuantity() {
        if (this.quantity > 1 && this.compare_min < this.quantity && this.getValidSelectedZone) this.quantity -= 1;
    }

    changeProductVariant(product: Product) {
        this.product = product;
        this.productImages = [...this.product?.images || []];
        // @ts-ignore
        this.defaultProduct?.imageUrl = this.productImages[0] || '../../../../../assets/imgs/product-card/no-product-image.png';
    }

    changeSelectedImage(imageUrl: string) {
        // @ts-ignore
        this.defaultProduct?.imageUrl = imageUrl;
    }

    addToCart() {
        if (this.authService.isAuthenticated()) {
            if (this.quantity !== 0 && this.getValidSelectedZone) {
                if (this.defaultProduct?.extraData?.length !== 0) {
                    this.showPhoneNumberModal();
                } else if (this.defaultProduct?.age_valid && !this.cookieService.get('valid_age')) {
                    this.showAgeModal();
                } else {
                    this.generalAddToCart();
                }
            }
        } else {
            this.loginToAddCartDialog();
        }
    }

    private loginToAddCartDialog() {
      this.dialog.open(LoginToAddCartDialogComponent, {
        width: '400px',
        disableClose: true,
        data: {
          messageUppercase: true,
          cancelAction: 'CANCEL',
          confirmAction: 'GO_TO_LOGIN',
          message: "TO_PERFORM_THIS_ACTION_YOU_MUST_LOG_IN",
        }
      });
    }

    get getSelectedZones(): SelectedZone {
        return this.zonesService.getZonesValuesStorage();
    }

    get getValidSelectedZone(): boolean {
        const selectedZone = this.getSelectedZones;
        if (selectedZone?.area_selected) {
            if (selectedZone.area_selected === 'CU') {
                return !!selectedZone.zone && !!selectedZone.municipality;
            }
            return !!selectedZone.zone;
        }
        return false;
    }

    private generalAddToCart(data_extras?: ExtraData) {
        this.isLoadingCart = true;
        if (!this.currentUser?.id) {
          this.currentUser = this.authService.getCurrentUser();
        }
        if (this.currentUser?.id) {
            this.addItemToCart(data_extras);
        }
    }

    private addItemToCart(data_extras?: ExtraData, isCartUrl: boolean = false) {
      if (this.currentUser?.id) {
        this.newCartService.addItemToCart({
          variantId: String(this.product?.id),
          count: this.quantity,
          zoneId: `${this.getSelectedZone.zone}`,
          municipalityId: `${this.getSelectedZone.municipality}`,
          extraData: data_extras ? [data_extras] : [],
          queryId: this.queryId,
          queryPosition: this.queryPosition,
        })
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (response) => {
              this.isLoadingCart = false;
              this.quantity = 1
              this.newCartService.blockAddToCardEvent(false);
              if (!response.data && response.responseCode === ErrorsEnum.PENDING_STORE_ORDER) {
                this.showPendingOrderModal();
              } else if (isCartUrl) {
                this.navigateToNewCart();
              }
            },
            error: (error) => {
              this.isLoadingCart = false;
              this.newCartService.blockAddToCardEvent(false);
              if (error?.error?.responseCode === ErrorsEnum.PENDING_STORE_ORDER) {
                return this.showPendingOrderModal();
              }
              return this.apiService.handleErrors(error, true);
            },
            complete: () => {
              this.isLoadingCart = false;
              this.newCartService.blockAddToCardEvent(false);
            }
          });
      }
    }

    showPendingOrderModal() {
        let dialoRef = this.dialog.open(PendingOrdersConfirmationComponent, {
            disableClose: false,
            // position: { top: '60px' }
        });
        dialoRef.afterClosed()
            // .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: ((data: any) => {
                    if (data?.success && data?.type) {
                        switch (data.type) {
                            case 'payment':
                                this.newCartService.removeCartValuesInStorage(() => {
                                    localStorage.setItem(NewCheckoutEnum.PAYMENT, JSON.stringify({ data: false }));
                                    this.router.navigate([`/${this.getSelectedZone?.area_selected?.toLowerCase()}/cart/checkout/payment`]);
                                });
                                // }
                                break;
                            case 'cart':
                                this.router.navigate([`/${this.getSelectedZone?.area_selected?.toLowerCase()}/cart/new`]);
                                break;
                            case 'home':
                                break;
                        }
                    }
                }),
                error: (err => {
                    throw new Error(err);
                })
            });
    }

    showPhoneNumberModal() {
        let dialoRef = this.dialog.open(PhoneRechargeSelectionComponent, {
            disableClose: false,
            position: { top: '60px' }
        });
        dialoRef.afterClosed()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: ((data: any) => {
                    if (data?.modified) {
                        // @ts-ignore
                        this.generalAddToCart({ [this.defaultProduct?.extraData![0]?.id]: data.data });
                    }
                }),
                error: (err => {
                    throw new Error(err);
                })
            });
    }

    setCustomQuantity() {
        if (this.defaultProduct?.extraData?.length == 0 && this.getValidSelectedZone) {
            let dialoRef = this.dialog.open(CutomQuantityModalComponent, {
                disableClose: false,
                data: this.compare_top
                // position: { top: '60px' }
            });
            dialoRef.afterClosed()
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: ((data: any) => {
                        if (data != null) {
                          this.quantity = data
                        }
                    }),
                    error: (err => {
                        throw new Error(err);
                    })
                });
        }
    }

    showAgeModal() {
        let dialoRef = this.dialog.open(AgeModalComponent, {
            disableClose: false,
            // position: { top: '60px' }
        });
        dialoRef.afterClosed()
            // .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: ((data: any) => {
                    if (data) this.cookieService.set('valid_age', 'true', { path: '/' });
                }),
                error: (err => {
                    throw new Error(err);
                })
            });
    }

    private navigateToNewCart() {
        this.router.navigate([`/${this.getSelectedZone?.area_selected?.toLowerCase()}/cart/new`]);
    }

    loadDynamicQueriesByKey(key: string) {
        this.skeletons = [1, 2, 3, 4, 5]
        const languageAux = localStorage.getItem("language");
        let language = languageAux ? JSON.parse(languageAux) : null;
        const VARIABLES: any = {
            locale: language, countryCode: this.getSelectedZone?.area_selected?.toLowerCase() || 'cu',
            env: this.dynamicConfigService.getEnv(),
            zoneId: this.getSelectedZone?.zone,
            municipalityId: this.getSelectedZone?.municipality,
            productId: this.defaultProduct?.objectID
        };
        let DYNAMIC_QUERY_VARIABLES: any = [];
        let global_settings: any = {};

        this.dynamicConfigService.getFrontendSettings(language).subscribe((data: any) => {
            global_settings.SETTINGS = data;
            let query = global_settings?.SETTINGS?.data[0]?.attributes?.query_discoveries?.data
                .find((element: any) => element?.attributes?.Key == key);
            const DYNAMIC_QUERY = query?.attributes?.Query?.Uri;
            query?.attributes?.Query?.Variables.map((element: any) => {
                DYNAMIC_QUERY_VARIABLES.push({ key: element, value: VARIABLES[`${element}`] });
            });
            DYNAMIC_QUERY_VARIABLES.push({ key: 'query_discovery_key', value: key });
            this.searchQuery(DYNAMIC_QUERY, DYNAMIC_QUERY_VARIABLES, key);
        })
    }

    private searchQuery(HOME_SETTINGS_QUERY: any, HOME_SETTINGS_QUERY_VARIABLES: any, key: any) {
        this.dynamicConfigService.doDynamicQuery(HOME_SETTINGS_QUERY, HOME_SETTINGS_QUERY_VARIABLES)
            .subscribe((data: any) => {
                this.skeletons = [];
                if (key == 'bought-together') {
                    this.bought_together_products = data?.data?.items?.map((product: any) => {
                        return {
                            ...product,
                            store: product?.stores?.[0]?.id ? this.storeService.getStoreById(product?.stores[0]?.id) : of(undefined)
                        }
                    }) || [];
                } else {
                    this.relatedProducts = data?.data.items.map((product: any) => {
                        return {
                            ...product,
                            store: product?.stores?.[0]?.id ? this.storeService.getStoreById(product?.stores[0]?.id) : of(undefined)
                        }
                    });
                }
            });
    }



  addToShoppingList() {
    if (this.authService.isAuthenticated()) {
      if (this.quantity !== 0 && this.getValidSelectedZone) {
        if (this.defaultProduct?.age_valid && !this.cookieService.get('valid_age')) {
          this.showAgeModal();
        } else {
          this.openAddToShopListDialog();
        }
      }
    } else {
      this.loginToAddCartDialog();
    }
  }

  private openAddToShopListDialog() {
    this.dialog.open(AddToShopListComponent, {
      disableClose: true,
      data: {
        variantId: String(this.product?.id),
        count: this.quantity,
      }
    }).afterClosed()
      .pipe(filter((name) => name))
      .subscribe((response) => {
        const {success, shoppingListId} = response;
        if (success) {
          this.dialog.open(ConfirmDialogComponent, {
            disableClose: true,
            data: {
              messageUppercase: true,
              action: of({success: true}),
              confirmAction: 'ACCEPT',
              cancelAction: 'SHOPPING_LIST_GO_TO_SHOPPING_LIST',
              message: "ADDED_TO_SHOP_LIST_SUCCESS",
            }
          }).afterClosed()
            .subscribe((response) => {
              if (!response.success) {
                this.router.navigate(['/profile/shop-lists', shoppingListId]);
              }
            });
        }
      });
  }
}
